import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiClient } from "@/api/client";
import type { components } from "@/api/schema";

import { stockKeys } from "./query-keys";

type Marketplace = components["parameters"]["Marketplace"];

export interface ResetTarget {
  sku: string;
  marketplace: Marketplace;
}

export function useCalculateReset() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (targets: ResetTarget[]) => {
      const { error } = await apiClient.POST("/v1/stock/calculate-reset", {
        body: { targets },
      });
      if (error) throw error;
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: stockKeys.lists });
    },
  });
}
